import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Assistenza } from "app/components/models/assistenzaData";
import { Observable } from "rxjs";
import { MessageService } from "./message.service";

@Injectable({
    providedIn: 'root'
})

export class AssistenzaService {

    private urlAssistenza = location.origin + '/api/communication/assistenza/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);

    constructor(private http: HttpClient, private messageService: MessageService) { }

    getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    /** ADD ASSISTENZA - CHILD */
    addAssistenza(creaAssistenza: Assistenza): Observable<any> {
        return this.http.post<any>(`${this.urlAssistenza}new`, creaAssistenza, { headers: this.getToken() })
            .pipe();
    }

    /** ADD ASSISTENZA - PARENT */
    addAssistenzaParent(creaAssistenza: Assistenza): Observable<any> {
        return this.http.post<any>(`${this.urlAssistenza}parent/new`, creaAssistenza, { headers: this.getToken() })
            .pipe();
    }

    getAssistenzaParentList(): Observable<any> {
        return this.http.get<any>(`${this.urlAssistenza}parent/list`, { headers: this.getToken() })
            .pipe();
    }

    getAssistenzaParentListByUser(isAdmin): Observable<any> {
        return this.http.get<any>(`${this.urlAssistenza}parent/list/user?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe();
    }

    getAssistenzaListByThreadId(threadId): Observable<any> {
        return this.http.get<any>(`${this.urlAssistenza}list/${threadId}`, { headers: this.getToken() })
            .pipe();
    }

    getParentAssistenza(threadId): Observable<any> {
        return this.http.get<any>(`${this.urlAssistenza}parent/${threadId}`, { headers: this.getToken() })
            .pipe();
    }



}